// UpdatePushNotificationPreferences updates the push notification preferences for the specified device
export const PushNotificationsService_UpdatePushNotificationPreferencesLazy =
  () =>
    import("./push_notifications_service.grpc").then(
      (m) => m.PushNotificationsService_UpdatePushNotificationPreferences
    );
PushNotificationsService_UpdatePushNotificationPreferencesLazy.method =
  "pushnotifications.v1.PushNotificationsService/UpdatePushNotificationPreferences" as const;
